import { render, staticRenderFns } from "./Nan.vue?vue&type=template&id=0313504a&"
import script from "./Nan.vue?vue&type=script&lang=ts&"
export * from "./Nan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports